import React from 'react'
import classNames from 'classnames'
import { IInfoPopoverProps } from './interface';

import './styles.scss'

const bc = 'info-popover'

const InfoPopover: React.FC<IInfoPopoverProps> = ({ t, title, text, action, actionText = 'Got it', className, messagePopup, dangerouslyText }) => (
  <div className={classNames(bc, { [className]: !!className })}>
    {title ? <div className={`${bc}__title`}>{title}</div> : null}
    {text && (
      <span className={classNames({ [`${bc}__message--popup`]: messagePopup, [`${bc}__text`]: !messagePopup })}>
        {text}
      </span>
    )}
    {dangerouslyText && (
      <div
        className={classNames({ [`${bc}__message--popup`]: messagePopup, [`${bc}__dangerouslyText`]: !messagePopup })}
        dangerouslySetInnerHTML={dangerouslyText}
      />
    )}
    <br />
    {action && (
      <div className={`${bc}__action`} onClick={() => action()}>
        {t(actionText)}
      </div>
    )}
  </div>
)

export default InfoPopover
